"use strict";

var ExportButton = require("app/shared/components/ExportButton/export-button");

var ExportOrganizationsButton = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    skipOptions: React.PropTypes.bool
  },
  getExtraOptions: function(selectionValue) {
    return {
      includeProductData: (selectionValue >= 1 ? 1 : 0)
    };
  },
  render: function() {
    let buttonText = this.props.skipOptions ? "Exportar empresas" : "Exportar";

    let options = [
      {value: 0, checked: true, text: "Empresas"},
      {value: 1, checked: false, text: "Empresas + Produtos"}];
    return <ExportButton onExport={this.props.onExport}
      getExtraOptions={this.getExtraOptions}
      options={options}
      skipOptions={this.props.skipOptions}
      buttonText={buttonText}
      exportName="empresa" />
  }
});

module.exports = ExportOrganizationsButton;



// WEBPACK FOOTER //
// ./app/screens/Organizations/components/ExportOrganizationsButton/export-organizations-button.jsx